import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // เพิ่ม useLocation
import { ENav, NavList } from "./enum";
import { ButtonImgStyle, ContainerStyle, PanelStyle } from "./styled";

export default (props) => {
  const {} = props;
  const navigate = useNavigate();
  const location = useLocation(); // ดึงข้อมูล location มาใช้
  const [tab, setTab] = React.useState(ENav.HOME);

  // ใช้ useEffect เพื่อตรวจสอบ path ทุกครั้งที่เปลี่ยนหน้า
  useEffect(() => {
    const path = location.pathname.split("/")[1]; // ดึงชื่อ path หลัง / อันแรก

    if (!path) {
      setTab(ENav.HOME);
    } else {
      // ค้นหา enum ที่ตรงกับ path ปัจจุบัน (แปลงเป็นตัวพิมพ์ใหญ่เพื่อให้ตรงกับ ENav)
      const currentTab = path.toUpperCase();
      if (Object.values(ENav).includes(currentTab)) {
        setTab(currentTab);
      }
    }
  }, [location]); // ทำงานใหม่ทุกครั้งที่ URL เปลี่ยน

  const goPage = (ptab) => () => {
    // ปรับการ navigate ให้สั้นลง และลดการ setTab ซ้ำซ้อนเพราะ useEffect จัดการให้แล้ว
    const path = ptab === ENav.HOME ? "/" : ptab.toLowerCase();
    navigate(path);
  };

  return (
    <ContainerStyle>
      {NavList.map((ptab) => (
        <PanelStyle
          key={ptab["enum"]} // ย้าย key มาไว้ที่ Component นอกสุดใน Loop
          className={tab === ptab["enum"] ? "selected" : ""}
        >
          <ButtonImgStyle
            src={ptab["src"]}
            onClick={goPage(ptab["enum"])}
            size={ptab["size"]}
          />
        </PanelStyle>
      ))}
    </ContainerStyle>
  );
};
